// phone-number.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneNumber'
})
export class PhoneNumberPipe implements PipeTransform {
    transform(value: string | undefined): string {
        if (!value) {
            return ''; // or handle it in another way based on your requirements
        }

        // Assuming the input is a 10-digit number
        const areaCode = value.substring(0, 3);
        const middlePart = value.substring(3, 6);
        const lastPart = value.substring(6, 10);

        return `(${areaCode}) ${middlePart} ${lastPart}`;
    }
}
